import Vue from "vue"
import VueI18n from "vue-i18n"

Vue.use(VueI18n)

let languages = []

/**
 * This function imports all lang jsons in a one-shot manner. There should not be
 * any reason to edit this file.
 */
const messages = {}
const files = require.context('./', false, /\.json$/)

files.keys().forEach(key => {
  if (key !== './index.js') {
    const lang = key.replace(/(\.\/|\.json)/g, '').toLowerCase()
    languages.push(lang)
    messages[lang] = files(key)
  }
})

// Create VueI18n instance with options
const i18n = new VueI18n({
  locale: document.documentElement.lang.substr(0, 2),
  silentTranslationWarn: true,
  fallbackLocale: 'en',
  messages
});

export { i18n, languages }